// IMPORTS
// --------------------------------------------------------
import styled from 'styled-components';
import Colors from '../../../../../../../styles/Colors';

// MAIN STYLED COMPONENTS
// --------------------------------------------------------
/**
 * Parent styles for component
 * @constant
 */

const StripeFormStyles = styled.div`
  text-align: center;
  input,
  .StripeElement {
    display: block;
    margin: 10px 0 20px 0;
    // max-width: 500px;
    padding: 10px 14px;
    font-size: 1em;
    font-family: 'Source Code Pro', monospace;
    box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
    border: 0;
    outline: 0;
    border-radius: 4px;
    background: white;
  }

  input::placeholder {
    color: #aab7c4;
  }

  input:focus,
  .StripeElement--focus {
    box-shadow: rgba(50, 50, 93, 0.109804) 0px 4px 6px, rgba(0, 0, 0, 0.0784314) 0px 1px 3px;
    -webkit-transition: all 150ms ease;
    transition: all 150ms ease;
  }

  .StripeElement.IdealBankElement,
  .StripeElement.FpxBankElement,
  .StripeElement.PaymentRequestButton {
    padding: 0;
  }

  .StripeElement.PaymentRequestButton {
    height: 40px;
  }

  .card-error {
    margin-top: 15px;
    color: red;
  }
`;
StripeFormStyles.Button = styled.button`
  margin: auto;
  width: 329px;
  height: 61px;
  background-color: #ff8a00;
  font-size: 24px;
  text-transform: uppercase;
  color: #ffffff;
  cursor: pointer;
  border: 0;
  :hover {
    background-color: #0098e4;
    color: #fff;
    box-shadow: 0px 0px 9px 0px rgb(47 143 205 / 25%);
  }
`;
export default StripeFormStyles;
